import { roleActions } from "./role";

export const roles_actions = {
  ...roleActions
};
export { default as rolesSlice } from "./role";
